import inDOM from 'dom-helpers/canUseDOM'
let afterFrame

if (inDOM) {
  afterFrame = require('afterframe').default
}

export default afterFrame
